// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width:720px){.activity_share .van-tabs__nav{background-color:rgba(33,37,39,.6)}.activity_share .van-tab{color:#efefef}.activity_share .van-tab--active{color:#fff}.activity_share .van-image__error,.activity_share .van-image__loading{background-color:rgba(33,37,39,.6)}}", ""]);
// Exports
module.exports = exports;
